import { render, staticRenderFns } from "./AddRappels.vue?vue&type=template&id=5c570603&scoped=true&lang=true&"
import script from "./AddRappels.vue?vue&type=script&lang=js&"
export * from "./AddRappels.vue?vue&type=script&lang=js&"
import style0 from "./AddRappels.vue?vue&type=style&index=0&id=5c570603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c570603",
  null
  
)

export default component.exports